import { TouchableOpacity, View } from 'react-native';
import { Text } from '@/components/Text';
import { DropDownItemType } from './types';
import { Icon } from '../../Icon';

type Props = {
  item: DropDownItemType;
  onItemPress: (title: string) => void;
};

export const DropdownItem = ({ item, onItemPress }: Props) => {
  const { title, bold, iconName, iconColor, hide } = item;

  const onPress = () => {
    onItemPress(title);
  };

  if (hide) {
    return null;
  }

  return (
    <TouchableOpacity
      activeOpacity={0.3}
      className="hover:bg-red-300 flex justify-center p-2 m-1 bg-slate-100 rounded-md"
      onPress={onPress}
      testID={`dropdown-item-${title}`}
    >
      <View className="flex flex-row items-center">
        {iconName ? (
          <Icon className={`text-xl ${iconColor} mr-1`} name={iconName} />
        ) : null}
        <Text className={`text-xl ${bold ? 'font-semibold' : ''}`}>
          {item.title}
        </Text>
      </View>
    </TouchableOpacity>
  );
};
